import React from 'react'
import {Table} from 'react-bootstrap'
import accounting from 'accounting'
import {countries} from '../../helpers/countries'
import {t} from '../../helpers/translate.js'
let config = require('config');

class HistoryComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      changeList: []
    };
  }

  componentWillMount() {
    this.updateHistory(this.props.groups, this.props.history);
  }

  componentWillReceiveProps(nextProps) {
    this.updateHistory(nextProps.groups, nextProps.history);
  }

  updateHistory(groups, history) {
    this.setState({
      'changeList':
        groups
          .reduce(HistoryComponent.matchChanges.bind(null, history), [])
          .sort(HistoryComponent.compareDates)
          .reduce(HistoryComponent.groupByDate, [])
    });
  }

  static matchChanges(history, prevChanges, group) {
    if (group.check_history && group.check_history === true) {
      var keys = group.fields.filter((field) => field.key_path).map((field) => field.key_path.join('.'));
      
      history.map((change) => {
        let matchedChange =
          HistoryComponent.matchChange(change, group, keys);

        if (matchedChange) {
          prevChanges.push(matchedChange);
        }
      });
    }

    return prevChanges;
  }

  static matchChange(change, group, keys) {
    var i = keys.indexOf(change.key);

    if (i !== -1) {
      let groupFields = group.fields.filter((field) => field.key_path);

      change.group_name = group.group_name;
      change.field_name = groupFields[i].as;

      let field = groupFields[i].key_path[groupFields[i].key_path.length - 1];

      if (['deductible', 'coverage'].indexOf(field) !== -1) {
        change.old_value = accounting.formatMoney(change.old_value);
        change.new_value = accounting.formatMoney(change.new_value);

      } else if (['country_code', 'country_of_origin', 'destination'].indexOf(field) !== -1) {
        let parsedOld = countries().find(
          (country) => {return country.value === change.old_value}
        );

        let parsedNew = countries().find(
          (country) => {return country.value === change.new_value}
        );

        change.old_value = parsedOld && parsedOld.text || change.old_value;
        change.new_value = parsedNew && parsedNew.text || change.new_value;
      } else if (['payment', 'process_failed_payments'].indexOf(field) !== -1) {
        change.old_value = 'Failed';
        change.new_value = 'Paid';
      } 

      return change;
    }

    return null;
  }

  static compareDates(a, b) {
    return b.change_date.localeCompare(a.change_date);
  }

  static groupByDate(prevChanges, change) {
    let changeGroup = prevChanges.pop() || [];

    if (changeGroup.length > 0 && change.change_date !== changeGroup[0].change_date) {
      prevChanges.push(changeGroup);
      changeGroup = [change];
    } else {
      changeGroup.push(change);
    }

    prevChanges.push(changeGroup);
    return prevChanges;
  }

  render() {
    if (this.state.changeList.length > 0) {
      return <div>
        <Table hover>
          <thead>
          <tr>
            {['User', 'Change Date/Time', 'Section', 'Field', 'From', 'To'].map((th, index) => <th key={index}>{t(th)}</th>)}
          </tr>
          </thead>
          <tbody className='word-break'>
          {this.state.changeList.map(
            (changeGroup) => changeGroup.map(
                (change, index) => {
                  let groupInfo = index === 0 ?
                    [
                      <td rowSpan={changeGroup.length}>{change.changed_by}</td>,
                      <td rowSpan={changeGroup.length}>{change.change_date}</td>
                    ] : null;

                  return <tr>
                    {groupInfo}
                    <td>{t(change.group_name)}</td>
                    <td>{t(change.field_name)}</td>
                    <td>{change.old_value}</td>
                    <td>{change.new_value}</td>
                  </tr>
                }
              )
          )}
          </tbody>
        </Table>
      </div>
    }

    return null;
  }
}
HistoryComponent.displayName = 'HistoryComponent';
export default HistoryComponent;



// WEBPACK FOOTER //
// ./src/components/common/HistoryComponent.js